<template>
  <!-- 永辉测试界面 -->
  <div class="wrap-b">
    <Spin fix class="ivu-spin-fullscreen" :class="{'dt-none': isLoading === false }">
      <Icon type="load-c" size="18" class="demo-spin-icon-load"></Icon>
      <div>{{loadingText}}</div>
    </Spin>
    <div class="map-layout">
      <header class="head-style">
        <span class="title-cont title-style bold">拜访客户</span>
        <span class="title-cont title-style">{{dayCust}}个</span>
        <span class="title-cont title-style bold">预计行程</span>
        <span class="title-cont title-style">{{totalKm}}km</span>
        <span class="title-cont title-style bold" style="clear: left">运载重量</span>
        <span class="title-cont title-style">{{totalWeight}}kg</span>
        <Button type="primary" class="btn-table" @click="clickShowCalendar">{{showCalendarName}}</Button>
        <Button
          v-show="false"
          type="primary"
          class="btn-table margin-right-10"
          @click="clickShowTab"
        >{{shoTabName}}</Button>
      </header>
      <div class="right" v-show="showCalendar">
        <div class="visit-panel">
          <div class="select-user-panel select-condition">
            <div class="select-user-block">
              <span class="select-user-title">城市</span>
              <Select
                v-model="citySlect"
                class="select-user text-center margin-top-10"
                @on-change="changeCity(citySlect)"
              >
                <Option
                  v-for="city in cities"
                  :key="city.value"
                  :value="city.value"
                >{{ city.label }}</Option>
              </Select>
            </div>
            <div class="select-user-block">
              <span class="select-user-title">业务员</span>
              <Select
                v-model="userSelect"
                class="select-user text-center margin-top-10"
                :label-in-value="true"
                @on-change="changeUser"
              >
                <Option
                  v-for="user in userAlls"
                  :key="user.label"
                  :value="user.value"
                >{{ user.label }}</Option>
              </Select>
            </div>
          </div>
          <div id="calendar" class="margin-top-8"></div>
          <div class="current-month-num current-month-heitht">
            <p class="title">总计</p>
            <div class="current-month-num-body">
              <div class="all-line-info font-bold">
                <span class="with-50">车辆数量</span>
                <span>{{carCount}}</span>个
              </div>
              <div class="all-line-info font-bold">
                <span class="with-50">客户数量</span>
                <span>{{custCount}}</span>个
              </div>

              <Col class="all-line-info font-bold">
                <span class="with-50">总计行程</span>
                <span>{{visitDistance}}</span>
              </Col>
            </div>
          </div>
          <div v-show="false" class="future-visit-panel height-295">
            <p class="title">未排入本月PJP的客户（{{futureVisit.length}}）</p>
            <div class="future-visit-panel-body">
              <div class="visit-item" v-for="visit in futureVisit">
                <Col span="12" class="visit-custorm">{{visit.attrs.CustomerName}}</Col>
                <Col span="12" class="add-daily" style="text-align:right;">
                  <span>+</span>
                  加入日程
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="left" ref="mapPanel" :class="!showCalendar ? 'update-width' : ''">
        <Table v-show="showTable" :columns="tableTitle" :data="tableItems" class="table-style"></Table>
        <div id="mapContainer" class="map-style"></div>
      </div>
    </div>
  </div>
</template>
<script>
import "../assets/stylesheets/map_demo.scss";
import "../assets/stylesheets/calendar.css";
import "../assets/javascript/jquery.min.js";
import "../assets/javascript/calendal_demo.js";
import api from "../service/api";
import getData from "../service/getData";
import getColor from "../service/randomColor.js";
import io from "socket.io-client";
import config from "../../config/config.js";
import moment from "moment";
import demoUser from "../data/demoUser.js";
import { setTimeout } from "timers";
import {
  initMap,
  openMarWindow,
  openLineWindow
} from "../assets/javascript/map.js";

export default {
  data: function() {
    return {
      isLoading: false,
      loadingText: "加载中...",
      dayCust: 0,
      totalKm: 0,
      totalWeight: 0,
      endTime: "00:00",
      citySlect: "上海",
      allMarkerGroup: new L.featureGroup(),
      cities: [
        {
          value: "上海",
          label: "上海"
        }
      ],
      tableTitle: [
        {
          title: "序号",
          key: "num",
          width: 60
        },
        {
          title: "客户名称",
          key: "name",
          width: 160,
          maxWidth: 1000
        },
        {
          title: "到达时间",
          key: "arriveTime",
          width: 90
        },
        {
          title: "离开时间",
          key: "leaveTime",
          width: 90
        }
      ],
      tableItems: [],
      userSelect: 999,
      userAlls: [
        {
          value: 999,
          label: `全部车辆`
        }
      ],
      currentUser: {},
      custCount: 0, //全部的客户数
      carCount: 0,
      visitDistance: 0,
      futureVisit: [],
      layerGroup: new L.layerGroup(),
      pointsMap: new Map(), //全部的客户
      dateLineMap: new Map(), //每一天的线路详情
      layerMap: new Map(), //用来存储现在显示的
      dateMap: new Map(), //用来保存日期和数组对应(i,2018-09-01)
      allDays: {},
      changeMonth: true,
      showTable: false,
      showCalendar: true,
      showCalendarName: "隐藏日历",
      shoTabName: "展示列表",
      month: "2019-01",
      lineMap: new Map(), //保存每一天的线路信息
      focusLayers: [], // 焦点图层
      focusLineLayer: null,
      focusMarker: null // 焦点点位
    };
  },
  computed: {},
  mounted() {
    //初始化地图
    this.map = initMap(
      "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetGray/MapServer/tile/{z}/{y}/{x}"
    );
    this.map.on("popupclose", this.clearFocus);
    this.layerGroup.addTo(this.map);
    this.getRegionData();
    this.month = moment().format("YYYY-MM");
  },
  methods: {
    changeUser: function(obj) {
      const lindIndex = obj.value;
      for (let layersGroup of this.layerMap.values()) {
        layersGroup.remove();
      }
      if (lindIndex === 999) {
        for (let layersGroup of this.layerMap.values()) {
          layersGroup.addTo(this.map);
          this.map.fitBounds(layersGroup.getBounds());
        }
        this.dayCust = 0;
        this.totalKm = 0;
        this.totalWeight = 0;
        for (let [key, lineInfo] of this.lineMap) {
          this.dayCust += lineInfo.planedOrders.length - 2;
          this.totalKm += lineInfo.route.distance;
          this.totalWeight += lineInfo.route.weight;
        }
        this.totalKm = (this.totalKm / 1000).toFixed(2);
      } else {
        const lineInfo = this.lineMap.get(lindIndex);
        this.dayCust = lineInfo.planedOrders.length - 2;
        this.totalKm = (lineInfo.route.distance / 1000).toFixed(2);
        this.totalWeight = lineInfo.route.weight;
        this.getDayInfo(lindIndex);
      }
    },
    /**
     * 焦点路线
     */
    setFocusLineLayer(layers, latLngs) {
      this.clearFocusLineLayer();
      for (let layer of layers) {
        if (layer.setZIndexOffset) {
          layer.setZIndexOffset(999);
        }
      }
      if (!this.focusLineLayer) {
        this.focusLineLayer = L.polyline(latLngs, {
          color: "#ff0000",
          weight: 5
        });
      } else {
        this.focusLineLayer.setLatLngs(latLngs);
      }
      this.focusLineLayer.addTo(this.map).bringToFront();
      this.focusLayers = layers;
    },
    clearFocusLineLayer() {
      for (let layer of this.focusLayers) {
        if (layer.setZIndexOffset) {
          layer.setZIndexOffset(0);
        }
      }
      this.focusLayers = [];
      if (this.focusLineLayer) {
        this.focusLineLayer.remove();
      }
    },
    clearLayer() {
      for (let layersGroup of this.showLayerGroup) {
        layersGroup.remove();
      }
    },
    clearFocus() {
      this.clearFocusLineLayer();
      this.clearFocusMarker();
    },
    /**
     * 点位焦点
     */
    setFocusMarker(e) {
      this.focusMarker = e.target;
      let dom = this.focusMarker.getElement();
      let className = dom.className;
      if (className.indexOf("focus-marker-point") === -1) {
        className += " focus-marker-point";
      }
      dom.className = className;
    },
    clearFocusMarker() {
      if (this.focusMarker) {
        let dom = this.focusMarker.getElement();
        if (dom !== null) {
          let className = dom.className;
          if (className.indexOf("focus-marker-point") > -1) {
            className = className.replace(" focus-marker-point", "");
          }
          dom.className = className;
        }
      }
      this.focusMarker = null;
    },
    clickShowTab: function() {
      this.showTable = !this.showTable;
      this.shoTabName =
        this.shoTabName === "展示列表" ? "隐藏列表" : "展示列表";
    },
    clickShowCalendar: function() {
      this.showCalendar = !this.showCalendar;
      this.showCalendarName =
        this.showCalendarName === "展示日历" ? "隐藏日历" : "展示日历";
      let self = this;
      setTimeout(function() {
        self.map.invalidateSize(true, { debounceMoveend: true });
      }, 100);
    },
    changeCity: function(city) {},
    /**
     * 获取每个用户的排班详情
     */
    getRegionData: async function(region) {
      const res = await getData.get(api.getFileData, {
        fileName: "永辉送货"
      });
      if (res.data && res.data.status) {
        const pointsAll = res.data.info.points_all;

        for (let pointInfo of pointsAll) {
          this.pointsMap.set(pointInfo.id, pointInfo);
        }
        this.custCount = pointsAll.length - 1;
        this.lineMap = new Map();
        let distance = 0;
        let durction = 0;
        for (let i = 0; i < res.data.info.line_info.length; i++) {
          let line = res.data.info.line_info[i];
          if (!line.isHoliday) {
            distance += line.route.distance;
            durction += line.route.duration;
          }
          this.lineMap.set(i, line);
          this.userAlls.push({
            value: i,
            label: `车辆${i + 1}`
          });
        }
        this.carCount = this.userAlls.length;
        this.visitDistance = `${(distance / 1000).toFixed(2)} km`;
        // this.visitDurction = `${(durction / 60).toFixed(2)} h`;

        this.drawAllData();
        this.allDays = {};
        this.createDataControl(this.allDays);
      }
    },
    drawAllData() {
      //步行:1 公交:2 驾车:3  公交+步行:21  公交+驾车+步行:231
      const vevehicle_map = { "1": "步行", "2": "公交", "3": "驾车" };
      //画全部的信息
      for (let [key, value] of this.lineMap) {
        if (!value) continue;
        const color = getColor.getColor();
        const layers = [];
        for (let i = 0; i < value.planedOrders.length; i++) {
          const reachTimeInfo = value.reachTimes[i];
          const pointId = reachTimeInfo.orderId;
          const point = this.pointsMap.get(pointId);
          let markerShow = i;
          if (pointId === "0") {
            markerShow = "仓";
          }
          const divHtml = `<div class='way-points' style='background-color:${color}'>${markerShow}</div>`;
          const wayDivIcon = new L.divIcon({
            html: divHtml,
            className: "leaflet-direction-icon"
          });
          let stayTime = 0;
          const marPups = [
            {
              name: "名称",
              cont: point.address
            },
            {
              name: "所在车辆",
              cont: `车辆${key + 1}`
            },
            {
              name: "规定到达",
              cont: point.startTime
            },
            {
              name: "规定离开",
              cont: point.endTime
            },
            {
              name: "预计到达",
              cont: reachTimeInfo.time
            },
            {
              name: "预计离开",
              cont: reachTimeInfo.leaveTime
            }
            // {
            //   name: "停留时长",
            //   cont: `${stayTime}分钟`
            // }
          ];
          let marker = L.marker([point.lat, point.lng], {
            icon: wayDivIcon,
            draggable: true
          }).on("click", e => {
            openMarWindow(e, marPups);
            this.setFocusMarker(e);
          });
          layers.push(marker);
          this.allMarkerGroup.addLayer(marker);

          //***************画线***************/
          const route = value.route.path[i];
          if (route) {
            let vehicles = [];
            for (let vehstr of route.vehicle_types) {
              if (vehstr.type === 1) {
                vehicles.push({
                  name: "步行",
                  cont: `${vehstr.distance}米`
                });
              } else if (vehstr.type === 2) {
                vehicles.push({
                  name: "公交",
                  cont: vehstr.busName.replace(/\(.*?\)/g, "")
                });
              } else if (vehstr.type === 3) {
                vehicles.push({
                  name: "驾车",
                  cont: `${(vehstr.distance / 1000).toFixed(2)}公里`
                });
              }
            }
            const attrRoutes = [];
            attrRoutes.push({
              name: "车辆名称",
              cont: `车辆${key + 1}`
            });
            attrRoutes.push({
              name: "分段名称",
              cont: `${i}-${i + 1}`
            });
            attrRoutes.push({
              name: "分段里程",
              cont: `${(route.distance / 1000).toFixed(2)}公里`
            });
            attrRoutes.push({
              name: "花费时长",
              cont: route.duration
                ? route.duration.toFixed(2) + "min"
                : `${0}min`
            });
            attrRoutes.push({
              name: "载重",
              cont: value.route.weight
            });
            attrRoutes.push({
              name: "通勤方式",
              vehicles
            });
            const latLngs = [];
            for (let item of route.path) {
              latLngs.push(item.reverse());
            }
            layers.push(
              L.polyline(latLngs, {
                color: color
              }).on("click", e => {
                openLineWindow(e, attrRoutes);
                this.setFocusLineLayer(layers, latLngs);
              })
            );
          }
        }
        const featureGroup = L.featureGroup(layers);
        featureGroup.addTo(this.map);
        this.layerMap.set(key, featureGroup);
      }
      this.map.fitBounds(this.allMarkerGroup.getBounds());
    },
    createDataControl(dates, getDate) {
      //data有的时候就用这个日期
      let self = this;
      $("#calendar").calendar({
        ifSwitch: true, // 是否切换月份
        hoverDate: false, // hover是否显示当天信息
        backToday: false, // 是否返回当天
        selected_data: "",
        dates,
        afterInit: function(today) {},
        onMonthChange: function(date) {
          //*切换月份重新请求
          //   const monthString = moment(date).format("YYYYMM");
          //   self.month = monthString;
          //   self.getRegionData(this.userSelect);
        },
        onClick: function(today, selectDay) {}
      });
    },
    getDayInfo: async function(date) {
      if (this.layerMap.has(date)) {
        this.layerMap.get(date).addTo(this.map);
        this.map.fitBounds(this.layerMap.get(date).getBounds());
      }
    }
  }
};
</script>
<style lang="less">
.map-layout .with-all-8 {
  width: calc(~"100% - 8px");
}
.wrap-b {
  height: 100%;
  position: relative;
  padding: 8px;
}
.height-200 {
  height: 230px !important;
}
.all-line-info {
  text-align: left;
  font-size: 10px;
  margin: 4px;
}
.font-bold {
  font-weight: bold;
  font-size: 12px !important;
}
.bold {
  font-weight: bold;
}
.with-50 {
  display: inline-block;
  width: 90px;
}
.title-style {
  width: 100px;
  text-align: left;
}
.map-layout .left .ivu-table-wrapper.table-style {
  width: 410px !important;
}
.table-style {
  .ivu-table {
    .ivu-table-overflowX {
      overflow-x: hidden;
    }
    overflow-x: hidden;
    overflow-y: auto !important;
  }
}

.head-style {
  width: calc(~"100% - 436px");
  float: left;
  height: 60px;
  border-bottom: 1px solid #c9d3e0;
  padding-top: 8px;
  padding-left: 16px;
}
.select-condition {
  margin-top: 0 !important;
  height: 52px !important;
  line-height: 52px !important;
}
.margin-top-10 {
  margin-top: 10px !important;
}
.margin-top-8 {
  margin-top: 8px;
}
.margin-right-10 {
  margin-right: 10px;
}
.float-left {
  float: left;
}
.btn-table {
  float: right;
  margin-top: -16px;
}
.title-cont {
  height: 22px;
  line-height: 22px;
  float: left;
  color: #576d8b;
  font-size: 14px;
}
.current-month-heitht {
  height: calc(~"100% - 55px") !important;
}
.height-295 {
  height: calc(~"100% - 295px") !important;
}
.focus-marker-point .way-points {
  background-color: #ff0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Yonghui.vue